var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.751 18.362a2.124 2.124 0 01-1.5-.616L3 14.496l1.006-.999 3.243 3.243a.708.708 0 001.005 0L19.994 5 21 5.998 9.253 17.746c-.4.396-.94.617-1.502.616z","fill":"#fff","fillRule":"evenodd"}));
}

Check.defaultProps = {"width":"15","height":"15","viewBox":"0 0 24 24"};

module.exports = Check;

Check.default = Check;
